
import {defineComponent} from "vue";
import {TextWithImageAbstractRestDto} from "@/api/pharma-cms-content-page/models";
import {stringHasContent} from "@/helpers/functions/string";
import {DocumentRestService} from "@/services/rest/master/DocumentRestService";
import {DpModuleEnum} from "@/api/enums/dp-module-enum";

export default defineComponent({
  name: "CpsOverviewItemAbstract",
  emits: ["exceptions"],
  props: {
    cpAbstract: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      docType: 'PAGE_IMG' as string,
      publicUrl: null as string | null,
    }
  },
  mounted() {
    this.fetchPublicUrl();
  },
  computed: {
    contentPageAbstract(): TextWithImageAbstractRestDto {
      return this.cpAbstract;
    },
    content(): string {
      if (this.contentPageAbstract.content && stringHasContent(this.contentPageAbstract.content)) {
        if (this.contentPageAbstract.content.length > 100) {
          return this.contentPageAbstract.content.substr(0, 100) + '...';
        }

        return this.contentPageAbstract.content;
      }

      return '';
    }
  },
  methods: {
    async fetchPublicUrl(): Promise<void> {
      if (this.contentPageAbstract.image_url) {
        this.publicUrl = this.contentPageAbstract.image_url;
        return;
      }

      try {
        if (this.contentPageAbstract.image_key) {
          this.publicUrl = await DocumentRestService.getInstance()
            .findPublicPreviewUrl(this.contentPageAbstract.image_key, DpModuleEnum.CMS);
        }
      } catch (exceptions: any) {
        this.$emit('exceptions', exceptions);
      }
    },
  }
});
